import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Encerramento de Inventário",
  path: "/patrimonio/patinventarioencerramento",
  name: "patrimonio-pat-inventario-encerramento",
  component: () => import("@/views/patrimonio/patinventarioencerramento/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.ENCERRAMENTODEINVENTARIONOVO_MENU_1200200399],
  },
  goesToMenu: true,
 },
];
